import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Scroll window to top
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Also reset common scrolling containers used in mobile/desktop layouts
    const selectors = ['.mobile-content-wrapper', '.container'];
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        try {
          el.scrollTo({ top: 0, behavior: 'instant' });
        } catch {
          el.scrollTop = 0;
        }
      });
    });

    // Track page view in Google Analytics
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: pathname + search,
        page_location: window.location.href,
      });
    }
  }, [pathname, search]);

  return null;
}
